<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<div>
			<div class="schmain">
				<div class="sch-ul" >
					<div class="sch-li" >
						<!-- <div class="schli-l"><img :src="UPLODE_URL+info.schoolLogos" alt="" /></div> -->
						<div class="schli-r">
							<div class="schli-rt">
								<span class="schli-rt-a">{{info.majorName}}</span>
								<!-- <span class="schli-rt-b">{{info.degree}}</span> -->
							</div>
							<div class="schli-rb">
								<!-- <span v-if="info.natureName">{{info.natureName}}</span>
								<span v-if="info.attribute">{{info.attribute}}</span>
								<span v-if="info.belong">{{info.belong}}</span>
								<span v-if="info.typeName">{{info.typeName}}</span> -->
								
								<!-- <span v-if="item.oneJihua!=0">{{item.oneJihua!=0?'101计划':''}}</span>
								<span v-if="item.zuoyueJihua==1">{{item.zuoyueJihua==1?'卓越工程师':''}}</span>
								<span v-if="item.youJihua==1">{{item.youJihua==1?'国优计划':''}}</span> -->
							</div>
						</div>
					</div>
					
					
					<div class="home_top_swiper">
						<!-- <div class="home_top_swiper_left">
							<el-carousel trigger="click" height="100%" :interval="3000" class="el-car">
								<el-carousel-item v-for="(item, index) in info.schoolImage" :key="index">
									<img :src="UPLODE_URL+item" alt="" class="img" />
								</el-carousel-item>
							</el-carousel>
						</div> -->
						<div class="home_top_swiper_right">
							<div class="introduction-rank-list">
								
								<div class="introduction-rank-list-box nnnew" v-if="info.majorCode">
									<div style="font-size: 12px;">专业代码</div>
									<div class="nnna">{{info.majorCode}}</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.limitYear">
									<div style="font-size: 12px;">修业年限</div>
									<div class="nnna">{{info.limitYear}}</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.degree">
									<div style="font-size: 12px;">授予学位</div>
									<div class="nnna">{{info.degree}}</div>
								</div>
								<!-- <div class="introduction-rank-list-box nnnew" v-if="info.qs">
									<div class="nnna">{{info.qs}}</div>
									<div>QS</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.us">
									<div class="nnna">{{info.us}}</div>
									<div>US</div>
								</div> -->
							</div>
							<div class="rightul">	
								<div class="rightli" v-if="info.selAdv">选科建议：{{info.selAdv}}</div>
								<div class="rightli" v-if="info.direction">考研方向：{{info.direction}}</div>
								<div class="rightli" v-if="info.celebrity">社会名人：{{info.celebrity}}</div>
								<div class="rightli" v-if="info.course">开设课程：{{info.course}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		
		
		
		<div class="boxA">
			<div class="box-tit"><span v-for="(item,index) in navData" :class="navDataIndex==index?'onsele':''" @click="navClick(index)">{{item}}</span></div>
			<!-- <div class="search-t">
				<el-input  placeholder="请输入院校名称" v-model="schoolName"  class="input-with-select" clearable>
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div> -->
			<div class="jiben" v-if="navDataIndex==0">
				<div class="jianjie">
					<div class="jianjie-t">专业简介</div>
					<div class="majjj">
						<div class="majjjli">
							是什么：{{info.isWhat?info.isWhat:'-'}}
						</div>
						<div class="majjjli">
							学什么：{{info.learnWhat?info.learnWhat:'-'}}
						</div>
						<div class="majjjli">
							干什么：{{info.doWhat?info.doWhat:'-'}}
						</div>
					</div>
				</div>
				<div class="jianjie">
					<div class="jianjie-t">专业详解</div>
						<div v-if="info.content&&info.content!='null'" class="jianjie-main" v-html="info.content"></div>
						<el-empty v-else :image-size="200"></el-empty>
				</div>
				
			</div>
			
			
			
			
			
			
			<div v-if="navDataIndex==1">
				<el-form :model="queryParams" v-if="token" ref="queryForm" size="small" :inline="true"  label-width="68px" @submit.native.prevent style="margin-bottom: 10px;">
					
				  <el-form-item label="" prop="">
				  	<el-select v-model="addDataB.year"  placeholder="请选择" @change="changeKaisheA">
				  		<el-option
				  			v-for="item in yearData"
				  			:key="item.year"
				  			:label="item.year"
				  			:value="item.year">
				  		</el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="" prop="">
				  	<el-select v-model="addDataB.subjectOne" clearable placeholder="请选择" @change="changeKaishe">
				  		<el-option
				  			v-for="item in subjectOne"
				  			:key="item.id"
				  			:label="item.lable"
				  			:value="item.id">
				  		</el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="" prop="">
				  	<el-select v-model="addDataB.cityName" clearable placeholder="请选择地区" @change="changeKaishe">
				  		<el-option
				  			v-for="item in cityList"
				  			:key="item.name"
				  			:label="item.name"
				  			:value="item.name">
				  		</el-option>
				  	</el-select>
				  </el-form-item>
				</el-form>
				<div class="schmain" v-if="token">
					<div v-if="addDataB.batchName" style="color:#F84C3C; padding: 30rpx 0 0 30rpx; font-size: 16px;">
						{{addDataB.batchName}}
					</div>
					<div class="sch-ul sch-ulHover" v-if="schList&&schList.length"  ref="scrollContainer" v-intersect="handleIntersect">
						<div class="sch-li" v-for="(item,index) in schList" @click="goInfo(item)" v-if="(user.userVip==0&&index<=4)||(user.userVip>0)||!token||token">
							<div class="schli-l"><img :src="UPLODE_URL+item.ruleName" alt="" /></div>
							<div class="schli-r">
								<div class="schli-rt">
									<span class="schli-rt-a">{{item.schoolName}} [{{item.schoolCode}}]</span>
									<!-- <span class="schli-rt-b">{{item.majorName}}·{{item.grade}}</span> -->
									<!-- <span class="t-con-2" style="color: #505559;font-size: 12px;margin-left: 10px;" v-if="item.zuoyueJihua!=0||item.oneJihua==1||item.youJihua==1">{{item.oneJihua!=0?'101计划 | ':''}}  {{item.zuoyueJihua==1?'卓越工程师 | ':''}}  {{item.youJihua==1?'国优计划':''}}</span> -->
								</div>
								<div class="schli-rb">
									<span v-if="item.majorName">专业：{{item.majorName}}</span>
								</div>
								<div class="schli-rb">
									<span v-if="item.grade">学科评估：{{item.grade}}</span>
								</div>
								<div class="schli-rb">
									<span>最低分/位次/计划：{{item.branch?item.branch/100:'-'}}/{{item.rank?item.rank:'-'}}/{{item.plan?item.plan:'-'}}</span>
								</div>
							</div>
						</div>
					</div>
					<el-empty v-else-if="schList.length==0" :image-size="200"></el-empty>
					
					<div style="position: relative; min-height: 20vh; padding: 0px 0 0 0px; transform: translate(23%, 10%);" v-if="user.userVip==0">
						<nVip  v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip>
					</div>
					
					
					
				</div>
				
				
			</div>
			
			<div class="jiben jiben-a" v-if="navDataIndex==2">
				 <!-- v-if="info.province" -->
				 
				
				<div class="employment-whereabouts card-box jianjie" v-if="info.jobdetailOne">
					<div class="employment-whereabouts-title">
						<span>就业行业分布</span>
					</div>
					<!-- <nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip> -->
					<div >
						<div class="employment-whereabouts-list" >
							<div class="employment-whereabouts-list-item"
								v-for="(item,index) in info.jobdetailOne" :key="index">
								<span>{{item.name}}</span>
								<div class="progress">
									<div class="progress-bg">
										<div class="progress-bg-active" :style="{width:item.rate+'%'}">
										</div>
									</div>
									<span>{{item.rate}}%</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				
				<div class="employment-whereabouts card-box jianjie" v-if="info.jobdetailTwo">
					<div class="employment-whereabouts-title">
						<span>地区分布</span>
					</div>
					<!-- <nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip> -->
					<div >
						<div class="employment-whereabouts-list" >
							<div class="employment-whereabouts-list-item"
								v-for="(item,index) in info.jobdetailTwo" :key="index">
								<span>{{item.area}}</span>
								<div class="progress">
									<div class="progress-bg">
										<div class="progress-bg-active" :style="{width:item.rate+'%'}">
										</div>
									</div>
									<span>{{item.rate}}%</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="employment-whereabouts card-box jianjie" v-if="info.jobdetailThree">
					<div class="employment-whereabouts-title">
						<span>岗位去向</span>
					</div>
					<!-- <nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip> -->
					<div >
						<div class="employment-whereabouts-list" >
							<div class="employment-whereabouts-list-item"
								v-for="(item,index) in info.jobdetailThree" :key="index">
								<span>{{item.detail_pos}}</span>
								<div class="progress">
									<div class="progress-bg">
										<div class="progress-bg-active" :style="{width:item.rate+'%'}">
										</div>
									</div>
									<span>{{item.rate}}%</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="employment-whereabouts card-box jianjie" v-if="info.job">
					<div class="employment-whereabouts-title">
						<span>专业就业</span>
					</div>
					<!-- <nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip> -->
					<!-- v-if="user.userVip==1" -->
					<div >
						<div class="employment-whereabouts-list" v-if="info.job&&info.job!='null'">
							<div  style="font-size: 15px;" v-html="info.job"></div>
						</div>
						<el-empty v-else :image-size="200"></el-empty>
					</div>
				</div>
				
				
			</div>
		
		
		</div>
			<!-- 学校列表 -->
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
	import nVip from '@/components/n-vip.vue';
export default {
	components: {
		nVip
	},
  data() {
    return {
		UPLODE_URL,
		token: localStorage.getItem('token')||'',
		user:JSON.parse(localStorage.getItem('user'))||'',
		id:'',
		navData:['专业概况','开设院校','就业方向'],
		subjectOne:[{lable:'分数排序',id:1},{lable:'学科排序',id:2}],//1分数排序，2学科排序
		cityList:[],
		navDataIndex:0,
		info:{},
		chineseArray:[],//学科评估汉字
		gradeArray:[],//学科评估 等级
		dexnNum:5,
		dexnNumB:5, 
		dexnNumC:5,
		dexnNumD:5,
		dexnNumE:5,
		dexnNumF:5,
		dexnNumG:5,
		// 查询参数
		queryParams: {
		  pageNum: 1,
		  pageSize: 10,
		  name:'',mobile:'',typeGui:''
		},
		addData:{
			year:'',
			cityId:'',
			batchId:'',
			yearZhao:'',
			batchIdZhao:'',
			majorName:'',
			majorNameZhao:'',
			
		},
		addDataB:{
			year:'',
			batchName:'',
			cityId:'',
			batchId:'',
			yearZhao:'',
			batchIdZhao:'',
			majorName:'',
			majorNameZhao:'',
			subjectOne:1,//排序
			pageNum:1
		},
		yearData:[],
		//专业分数线
		scores_line_list: [],
		scores_line_listZhao: [],
		//招生计划
		plan_list: [],
		batchIdData:[],
		schoolName:'',
		news_page:1,
		college_id:'',
		majorName:[{lable:'地方专项'},{lable:'中外合作'},{lable:'济南走读'},{lable:'面向青岛招生'},{lable:'定向西藏'}],
		schList:[],
		pageTotal:0,
		majorIdName:'',
		record:''
    };
  },
  directives: {
      intersect: {
        bind(el, binding) {
          const observer = new IntersectionObserver((entries, observer) => {
			  console.log('entries',entries)
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
				console.log('2222sdfsfs',img)
                // 在这里可以做图片的懒加载处理，比如更改src属性
                // img.src = img.dataset.src;
                // 或者触发其他的方法
                // binding.value(entry, observer);
                // observer.unobserve(img); // 停止观察
				// this.createObserver();
              }
            });
          });
   
          observer.observe(el);
        }
      }
    },
  created() {
    // 获取筛选省份
   
    		   this.api.homeCityListApi().then(res => {this.cityList = res.data})
     
  },
  mounted() {
	  window.addEventListener('storage', this.handleStorageEvent);
	 this.id = localStorage.getItem('majorId')
	 this.majorIdName = localStorage.getItem('majorIdName')
	 this.record = localStorage.getItem('record')
	  
  	 this.getList();
	 
	 
	 // 登录完 确定完 去请求录取接口
	 EventBus.$on("callLoginDialog", () => {
	 	this.token=localStorage.getItem('token')||''
	 	this.user=JSON.parse(localStorage.getItem('user'))||''
	 	this.morenYear()
	 });
	this.morenYear()
	 
  },
  beforeDestroy() {
	  window.removeEventListener('storage', this.handleStorageEvent);
    },
  methods: {
	
	  
	  // 跳转学校详情
	  goInfo(item){
	  		  // localStorage.setItem('xiaoid',item.id)
	  		  // this.$router.push({path:'/Ainformation/schoolInfo'})
	  		  // return
			  
			localStorage.setItem('schoolName','')
			localStorage.setItem('majorName','')
	  		const route =this.$router.resolve({name:'schoolInfo',})
	  		localStorage.setItem('xiaoid',item.schoolId)
	  		localStorage.setItem('majorName',item.majorName)
	  		// 打开新窗口并导航至生成的URL
	  		window.open(route.href, '_blank');
	  },
	  
	  
	  createObserver() {
	        const options = {
	          root: null, // viewport
	          rootMargin: '100px',
	          threshold: 1.0
	        };
	        const observer = new IntersectionObserver(this.handleIntersect, options);
	        observer.observe(this.$refs.loadMoreTrigger);
	      },
	  handleStorageEvent(event) {
	        if (event.key == 'token') {
	          // 更新登录状态
	  			this.token=localStorage.getItem('token')||''
	  			this.user=JSON.parse(localStorage.getItem('user'))||''
	  			this.$router.push({path:'/'})
	  			window.location.reload()
	          // this.checkLoginStatus();
	        }
	      },
	  // 接收子组件参数
	  handleChildEvent(i){
		  console.log('i',i)
		  // EventBus.$emit('noopsycheOpen');
		  // EventBus.$emit('open');
		  // EventBus.$emit('vipOpen');
		  if(i==1){
			  EventBus.$emit('noopsycheOpen');
		  }else if(i==2){
			EventBus.$emit('open');
		  }else{
			  EventBus.$emit('vipOpen');
		  }
	  },
	  // 筛选 change事件
	  changeA(){
		  this.getLu()
	  },
	  // 筛选 change事件
	  changeB(){
	  		  this.getZhao()
	  },
	  morenYear(){
		  this.token =  localStorage.getItem('token')||''
		  if(!this.user){
			 return 
		  }
		  this.api.homeDeYearoApi().then(res => {
			  this.getYear(res.data)
		})
	  },
	  getYear(year){
		  let quer = {
			  cityId:this.user.cityId,
			  type:1,
		  }
		  this.api.homeBranchTypeJiApi(quer).then(res => {
			  this.yearData = res.data
			  this.addDataB.year = res.data[0].year
			  this.addDataB.batchName = res.data[0].batchName
			  this.createObserver();
			  this.getshoolList(this.user.cityId,year)//获取历年录取数据
		  })
	  },
	  
	  handleIntersect(entry, observer){
		  if(this.navDataIndex!=1){
			  return
		  }
	  		  if (this.addDataB.pageNum >= this.pageTotal ) {
	  		   	// this.$message({
	  		   	//   message: '没有更多了',
	  		   	//   type: 'warning',
	  		   	//   duration: '4000'
	  		   	// });
	  		   	return
	  		   }
	  		   if(!this.token){
	  		   	EventBus.$emit('noopsycheOpen');
	  		   	return
	  		   }
	  		  if(!this.user.score){
	  		  	EventBus.$emit('showModal');
	  		  	return
	  		  }
	  		   if(this.user&&this.user.userVip==0){
	  		   	return
	  		   }
	  		   // this.busy = true
	  		  this.addDataB.pageNum++;
	  		  this.getshoolList('more')
	  		  
	  },
	  changeKaisheA(e){
	  		  console.log('eeee',e)
	  		  this.yearData.map(item=>{
	  			if(item.year==e){
	  				this.addDataB.batchName = item.batchName
	  			}
	  		  })
	  		   this.addDataB.pageNum = 1
	  		   this.getshoolList()
	  },
	  changeKaishe(){
		   this.addDataB.pageNum = 1
		   this.getshoolList()
	  },
	  getshoolList(type){
		  
		  // 数据列表请求
		  		   // let qu = {
		  			  //  schoolName:this.getschoolName=='schoolName'?this.queryParams.schoolName:'',
		  			  //  majorNames:this.getschoolName=='majorNames'?this.queryParams.schoolName:'',
		  			   
		  			  //  // city:this.addShowData.cityId=='全国'?'':this.addShowData.cityId,
		  			  //  pageNum:this.queryParams.pageNum,
		  			  //  // currentPage:this.news_page,
		  			  //  // size:5,
		  			  //  pageSize:10,
		  			  //  natureName:this.queryParams.natureName.toString()||'',
		  			  //  attribute:this.queryParams.attribute.toString()||'',
		  			  //  schoolType:this.queryParams.schoolType||'',
		  			  //  schoolCityOne:this.queryParams.schoolCityOne.toString()||'',
		  			  //  oneJihuas:this.queryParams.oneJihuas?'是':'',
		  			  //  zuoyueJihuas:this.queryParams.zuoyueJihuas?'是':'',
		  			  //  youJihuas:this.queryParams.youJihuas?'是':'',
		  			   
		  			  //  ruanke:this.queryParams.ruanke?1:0,
		  			  //  xiaoyouhui:this.queryParams.xiaoyouhui?1:0,
		  			  //  // wushulian:this.queryParams.wushulian?'是':'',
		  			  //  qs:this.queryParams.qs?1:0,
		  			  //  us:this.queryParams.us?1:0,
		  			  //  schoolLevel:this.queryParams.schoolLevel,//本科或者专科
		  		   // }
				   let quer = {
					 majorCodeAll:this.majorIdName,
					 year:this.addDataB.year,
					 subjectOne:this.addDataB.subjectOne,
					 cityName:this.addDataB.cityName||'',
					 pageNum:this.addDataB.pageNum,
					 batchId:this.record==0?8000:8001,
				   }
		  		    this.api.GetAppOpenSchoolApi(quer).then(res => {
		  				if(res.code==200){
		  					if (type == 'more') {
		  						if (!res.data) {
		  							// this.$message({
		  							// 	message: '没有更多了',
		  							// 	type: 'warning',
		  							// 	duration: '4000'
		  							// });
		  							return
		  						}
		  						this.schList = [...this.schList, ...res.data.rows];
		  						
		  					}else{
		  						this.schList = []
		  						this.schList = res.data ? res.data.rows : [];
		  						// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
		  						this.pageTotal = res.data ? res.data.pageTotal : 0;
		  					}
		  					
		  					
		  					// if(res.data&&res.data.rows){
		  					// 	this.pageTotal = res.data.pageTotal
		  					// 	this.schList = res.data.rows;
		  						
		  					// 	// this.schList = [...this.schList, ...res.data.rows];
		  						
		  					// }else{
		  					// 	this.schList = []
		  					// }
		  				}else{
		  					 this.$message.error(res.msg);
		  				}
		  			})
	  },
	  getLuPici(cityId,year){
		  let quer = {
		  		cityId:cityId,
		  }
		  this.api.appBatchLIstApi(quer).then(res => {
			  this.batchIdData=res.data
			  
		  	  this.addData.batchId =this.user.batchId||''
				
			  this.getLu(res.data[0].id,cityId,year)//获取历年录取数据
			  this.getZhao(res.data[0].id,cityId,year)
		  })
	  },
	  
	  
	  
	  // 获取录取数据表格
	  getLu(){
		  console.log('andjkahdjkbajksbjk')
		  let quer = {
				 batchId:this.addData.batchId,
				 cityId:this.user.cityId,
				 year:this.addData.year,
				 pageNum:this.news_page,
				 pageSize:100000000,
				 schoolId: this.id,
				 schoolName:this.schoolName||'',
				 majorName:this.addData.majorName
		  }
		  this.api.appLuApi(quer).then(res => {
			  console.log('res',res)
			  if(res.code==200){
				  if(res.data&&res.data.rows){
					  this.scores_line_list = res.data.rows
				  }else{
					  this.scores_line_list =[]
				  }
			  }
		  })
	  },
	  // 获取招生计划 数据表格
	  getZhao(){
		  console.log('andjkahdjkbajksbjk')
		  let quer = {
				 batchId:this.addData.batchId,
				 cityId:this.user.cityId,
				 year:this.addData.year,
				 pageNum:this.news_page,
				 pageSize:100000000,
				 schoolId: this.id,
				 schoolName:this.schoolName||'',
				 majorName:this.addData.majorName
		  }
		  this.api.appYearApi(quer).then(res => {
			  console.log('res',res)
			  if(res.code==200){
				  if(res.data&&res.data.rows){
					  this.scores_line_listZhao = res.data.rows
				  }else{
					  this.scores_line_listZhao =[]
				  }
			  }
		  })
	  },
	  
	  
	  
	  allA(){
		  if(this.dexnNum==5){
			  this.dexnNum=10000
		  }else if(this.dexnNum==10000){
			  this.dexnNum=5
		  }
	  },
	  allB(){
		  if(this.dexnNumB==5){
		  			  this.dexnNumB=10000
		  }else if(this.dexnNumB==10000){
		  			  this.dexnNumB=5
		  }
	  },
	  allC(){
		  if(this.dexnNumC==5){
		  			  this.dexnNumC=10000
		  }else if(this.dexnNumC==10000){
		  			  this.dexnNumC=5
		  }
	  },
	  allD(){
		  if(this.dexnNumD==5){
		  			  this.dexnNumD=10000
		  }else if(this.dexnNumD==10000){
		  			  this.dexnNumD=5
		  }
	  },
	  allE(){
		  if(this.dexnNumE==5){
		  			  this.dexnNumE=10000
		  }else if(this.dexnNumE==10000){
		  			  this.dexnNumE=5
		  }
	  },
	  allF(){
		  if(this.dexnNumF==5){
		  			  this.dexnNumF=10000
		  }else if(this.dexnNumF==10000){
		  			  this.dexnNumF=5
		  }
	  },
	  allG(){
	  		  if(this.dexnNumG==5){
	  		  			  this.dexnNumG=10000
	  		  }else if(this.dexnNumG==10000){
	  		  			  this.dexnNumG=5
	  		  }
	  },
	 navClick(i){
		 this.navDataIndex=i
		 if(i==1){
			if(!this.token){
			 	EventBus.$emit('noopsycheOpen');
			 	return
			 }
			if(!this.user.score){
				EventBus.$emit('showModal');
				return
			}
			 
		 }
	 },
	  // 获取筛选省份
	   city(){
		   this.api.homeCityListApi().then(res => {this.filtrate.F = res.data})
	   },
	  
	   schGet(){
		   this.queryParams.pageNum = 1;
		   this.getList()
	   },
	   // handleScroll(e) {
		  //  console.log('11111',e)
	   //       const bottomOffset = 50; // 距离底部多少像素时触发加载
	   //       const scrollContainer = this.$refs.scrollContainer;
	   //       if (scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight) < bottomOffset) {
	   //         this.getList();
	   //       }
	   //     },
	   // 数据列表请求
	   getList(type){
		   let qu = {
			   majorId:this.id
		   }
		   
		   
		    this.api.homeMajorInfoApi(qu).then(res => {
				if(res.code==200){
					let job = res.data.jobdetailOne ? JSON.parse(res.data.jobdetailOne) : null;
					res.data.jobdetailOne =job[1]?job[1]:null;
					res.data.jobdetailTwo =job[2]?job[2]:null;
					res.data.jobdetailThree =job[3]?job[3]:null;
					
					console.log('jobdetailThree',res.data.jobdetailThree)
					this.info = res.data
				}else{
					 this.$message.error(res.msg);
				}
			})
	   }
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		background: #fff;
		border-radius: 10px;
		padding: 10px 20px 20px 20px;
		margin-top: 10px;
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			margin-bottom: 15px;
			display: flex;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				cursor: pointer;
				display: block;
				text-align: center;
				font-size: 15px;
			}
			span.onsele{
				background-color: #F44F4D;
				color: #fff;
				border-radius: 10px 10px 0 0;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 30%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	
		.jiben{
			.introduction-rank-list{
				display: flex;
				.introduction-rank-list-box{
					font-size: 14px;
					background: linear-gradient(0deg,#f8f8f8,#f8f8f8);
					    width: 23%;
					    height: 30px;
					    text-align: center;
					    padding: 15px;
						margin-right: 15px;
						border-radius: 8px;
						.nnna{
							color: #F44F4D;
						}
				}
			}
		}
		// <div class="jianjie">
		// 	<div class="jianjie-t">专业简介</div>
		// 	<div class="majjj">
		// 		<div class="majjjli">
		// 			是什么：{{info.isWhat}}
		// 		</div>
		// 		<div class="majjjli">
		// 			学什么：{{info.learnWhat}}
		// 		</div>
		// 		<div class="majjjli">
		// 			干什么：{{info.doWhat}}
		// 		</div>
		// 	</div>
		// </div>
		.jianjie{
			margin-top: 20px;
			position: relative;
			.majjj{
				.majjjli{
					margin-bottom: 10px;
					font-size: 14px;
				}
			}
			.jianjie-t{
				font-size: 16px;
				color: #333;
				font-weight: bold;
				margin-bottom: 10px;
				display: -webkit-box;
				display: -webkit-flex;
				display: -ms-flexbox;
				display: flex;
				-webkit-box-pack: justify;
				-webkit-justify-content: space-between;
				-ms-flex-pack: justify;
				margin-top: 10px;
			}
			.jianjie-main{
				font-size: 14px;
				
			}
			
			.jianjie-m{
				font-size: 14px;
			}
			.admit-scoreLine-box-table-th{
				margin-bottom: 10px;
			}
			.admit-scoreLine-box-table-list{
				width: 100%;
				display: flex;
				.admit-scoreLine-box-table-list-div{
					flex: 1;
					margin-bottom: 6px;
					text-align: center;
				}
			}
			
			
			
			// <div class="sstj" >
			// 	<div class="sstjli" v-if="info.dormitoryStandard">
			// 		<img src="../../assets/img/ss1.png" alt="">
			// 		<div class="sstjlitext">{{info.dormitoryStandard?info.dormitoryStandard:'-'}}</div>
			// 	</div>
			// 	<div class="sstjli" v-if="info.campusWifi">
			// 		<img src="../../assets/img/ss2.png" alt="">
			// 		<div class="sstjlitext">{{info.campusWifi?info.campusWifi:'-'}}</div>
			// 	</div>
			// 	<div class="sstjli" v-if="info.bathroom">
			// 		<img src="../../assets/img/ss3.png" alt="">
			// 		<div class="sstjlitext">{{info.bathroom?info.bathroom:'-'}}</div>
			// 	</div>
			// 	<div class="sstjli" v-if="info.balcony">
			// 		<img src="../../assets/img/ss4.png" alt="">
			// 		<div class="sstjlitext">{{info.balcony?info.balcony:'-'}}</div>
			// 	</div>
			// </div>
			
			.sstj{
				display: flex;
				.sstjli{
					text-align: center;
					margin-right: 30px;
					img{
						width: 20px;
						height: 20px;
						background-color: #F5FAFE;
						border-radius: 5px;
						padding: 15px;
						margin-bottom: 4px;
					}
				}
			}
			
			
		}
	}
	
	
	.schmain{
		margin-top: 12px;
		.sch-ul{
			background: #fff;
			border-radius: 10px;
			// .sch-li:hover{
			// 	.schli-rt-a{
			// 		color: #F44F4D;
			// 	}
			// }
			.sch-li{
				
				display: flex;
				align-items: center;
				padding: 20px;
				.schli-l{
					width: 60px;
					height: 60px;
					margin-right: 20px;
					img{
						width: 60px;
						height: 60px;
						border-radius: 50%;
					}
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						display: flex;
						align-items: center;
						.schli-rt-a{
							font-size: 22px;
						}
						.schli-rt-b{
							margin-left: 10px;
							    height: 25px;
								line-height: 25px;
							    border-radius: 26px;
							    border: 1px solid #d8d8d8;
							    padding: 0 10px;
							    font-size: 12px;
							    color: #666;
						}
					}
					.schli-rb{
						margin-top: 6px;
						span{
							    height: 22px;
							    padding: 0 8px;
							    border-radius: 4px;
							    background: #f5f6f7;
							    font-size: 14px;
							    color: #666;
							    margin-right: 8px;
						}
					}
				}
			}

		
			// 顶部轮播图
			.home_top_swiper {
				width: 100%;
				padding:0 20px 20px 20px;
				position: relative;
				border-radius: 10px;
				display: flex;
				.home_top_swiper_left{
					width: 442px;
					height: 200px;
					margin-right: 20px;
				}
				.home_top_swiper_right{
					.introduction-rank-list{
						display: flex;
						margin-bottom: 20px;
						.introduction-rank-list-box{
							min-width: 110px;
							 height: 54px;
							    background: #fff9f2;
							    border-radius: 8px;
							    padding-top: 9px;
								padding: 5px 4px 0 4px;
							    border: 1px solid #fff0e6;
								text-align: center;
								margin-right: 10px;
								.nnna{
									font-size: 20px;
									color: #f60;
									margin-top: 5px;
								}
						}
					}
					
					
				
					.rightul{
						margin-top: 10px;
						.rightli{
							line-height: 31px;
							font-size: 15px;
							color: #666;
						}
					}
					
					
					
					
				}
				// background-color: #9b0e12;
				// width: 440px;
				// swiper左右按钮
				/deep/ .el-car {
					width: 100%;
					height: 100%;
				}
			
				img {
					width: 100%;
					height:100%;
					object-fit: cover;
					border-radius: 10px;
				}
			
				// /deep/.el-carousel__item{
				// height: 100%;
				// }
				/deep/.el-carousel__arrow {
					// background-color: #30384d;
					width:30px;
					height:30px;
					// border-radius: 0px;
				}
			
				// 左右按钮图标
				/deep/.el-icon-arrow-left {
					font-size: 20px
				}
			
				/deep/.el-icon-arrow-right {
					font-size: 20px
				}
			}
		
		}
	}

	// <div class="employment-whereabouts card-box">
	// 	<div class="employment-whereabouts-title">
	// 		<span>毕业生签约地区流向</span>
	// 	</div>
	// 	<!-- <nVip @child-event="handleChildEvent" v-if="userVip==0" version="旗舰版" name="就业数据"></nVip> -->
	// 	<!-- :class="userVip==0?'blur':''" -->
	// 	<div >
	// 		<div class="employment-whereabouts-list" >
	// 			<div class="employment-whereabouts-list-item"
	// 				v-for="(item,index) in info.province" :key="index">
	// 				<span>{{item.province}}</span>
	// 				<div class="progress">
	// 					<div class="progress-bg">
	// 						<div class="progress-bg-active" :style="{width:item.rate+'%'}">
	// 						</div>
	// 					</div>
	// 					<span>{{item.rate}}%</span>
	// 				</div>
	// 			</div>
	// 		</div>
	// 	</div>
	// </div>
	.employment-whereabouts{
		position: relative;
		.employment-whereabouts-title{
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			color: #333;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 10px;
			margin-top: 10px;
		}
		 .employment-whereabouts-list {
		    border: 1px solid #ececec;
		    border-radius: 6px;
		    padding: 17px 15px;
		    margin-top: 20px;
			 .employment-whereabouts-list-item {
			    display: flex;
			    flex-direction: column;
			    margin-bottom: 15px;
				span{
					font-size: 16px;
				}
				.progress {
				    display: flex;
				    flex-direction: row;
				    justify-content: space-between;
				    align-items: center;
					.progress-bg {
					    width: 88%;
					    height: 5px;
					    background-color: #ececec;
					    border-radius: 10px;
						.progress-bg-active {
						    background-color: #F24041;
						    border-radius: 10px;
						    height: 5px;
						}
					}
				}
			}
			
			
			
		}
		// 毕业生就业单位
		.employment-whereabouts-list{
			width: 50%;
			.employment-company-list{
				
				.employment-company-list-top{
					display: flex;
					justify-content: center;
					text-align: center;
					margin-bottom: 20px;
					div{
						flex:1;
						font-size:15px;
						color: #000;
					}
				}
				.employment-company-list-item{
					display: flex;
					justify-content: center;
					
					div{
						flex:1;
						font-size:13px;
						text-align: center;
						margin-bottom: 10px;
						color: #5A5A5A;
					}
				}
			}
		}
		// <div class="employment-whereabouts-list" >
		// 	<div class="employment-company-list" :class="" >
		// 		<div class="employment-company-list-top">
		// 			<div>序号</div>
		// 			<div>签约单位</div>
		// 			<div>人数</div>
		// 		</div>
		// 		<div class="employment-company-list-item"
		// 			v-for="(item,index) in info.company" :key="index">
		// 			<div>{{index}}</div>
		// 			<div><text>{{item}}</text></div>
		// 			<div>{{item?item:'-'}}</div>
		// 		</div>
		// 	</div>
		// </div>
	}

}
/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner{
			background-color: #F34240!important;
			    border-color: #F34240!important;
			    box-shadow: -1px 0 0 0 #F34240!important;
		}
		/deep/.el-input.is-active .el-input__inner{
			border-color: #F34240!important;
		} 
		/deep/.el-input__inner:focus{
			border-color: #F34240!important;
		}
		.el-select-dropdown__item.selected {
		  color: #F34240!important
		}
/deep/.el-carousel__indicator--horizontal{
	padding: 12px 2px;
}
.introduction-major-box-list-item{
	margin-bottom: 6px;
}
.admit-scoreLine-box-table-th-div{
	font-size: 14px;
	text-align: center;
}
.admit-scoreLine-box-table-list-div{
	font-size: 14px;
}
.sch-ulHover{
	cursor: pointer
}
</style>